export default "__VITE_ASSET__MJOoNROu__ 1034w, __VITE_ASSET__Z0bPGFxr__ 767w, __VITE_ASSET__fuq$mLTJ__ 500w";